import { CustomPageHeader, Text, CustomButton, CustomImage } from '@src/components';
import ProcessType from './ProcessType';
import BalanceOrderList from './BalanceOrderList';
import DeliveryApprovedList from './DeliveryApprovedList';
import CardOrderList from './CardOrderList';
import AutoUploadInstructionsList from './AutoUploadInstructionsList';
import { useSelector } from 'react-redux';
import TicketCarCardOrderList from './TicketCarCardOrderList';
import MobilePaymentPermision from './MobilePaymentPermision';
import { Fragment } from 'react';
import leftBack from '@src/assets/icons/icon-left-back.svg';
import { useHistory } from 'react-router-dom';
const componentsConfig = [
  { processTypes: [0, 1], notificationType: 1, component: <MobilePaymentPermision /> },
  { processTypes: [0, 2], notificationType: 2, component: <DeliveryApprovedList /> },
  {
    processTypes: [0, 3],
    notificationType: 3,
    component: <TicketCarCardOrderList />,
    requireApproval: true,
  },
  { processTypes: [0, 4], notificationType: 4, component: <AutoUploadInstructionsList /> },
  {
    processTypes: [0, 5],
    notificationType: 5,
    component: <BalanceOrderList />,
    requireApproval: true,
  },
  {
    processTypes: [0, 6],
    notificationType: 6,
    component: <CardOrderList />,
    requireApproval: true,
  },
  {
    processTypes: [0, 7],
    notificationType: 7,
    component: <DeliveryApprovedList isCompliments={true} />,
    requireApproval: true,
  },
  {
    processTypes: [0, 8],
    notificationType: 8,
    component: <DeliveryApprovedList isMarket={true} />,
    requireApproval: true,
  },
  {
    processTypes: [0, 9],
    notificationType: 9,
    component: <BalanceOrderList isMarket={true} />,
    requireApproval: true,
  },
  {
    processTypes: [0, 10],
    notificationType: 10,
    component: <CardOrderList isMarket={true} />,
    requireApproval: true,
  },
];

const shouldRenderComponent = (processType, isApproved, notificationList, config) => {
  const { processTypes, notificationType, requireApproval = false } = config;
  const isProcessValid = processTypes?.includes(processType);
  const isNotificationValid = notificationList?.some((item) => item?.type === notificationType);

  return requireApproval
    ? !isApproved && isNotificationValid && isProcessValid
    : isNotificationValid && isProcessValid;
};

const getComponents = (processType, isApproved, notificationList) => {
  return componentsConfig
    .filter((config) => shouldRenderComponent(processType, isApproved, notificationList, config))
    .map((config, index) => ({
      key: `component-${config.notificationType}-${index}`,
      component: config.component,
    }));
};

const PendingApproval = () => {
  const { processType, isApproved } = useSelector((state) => state?.packages);
  const { notificationList } = useSelector((state) => state?.notifications);
  const componentsToRender = getComponents(processType, isApproved, notificationList);
  const history = useHistory();

  return (
    <CustomPageHeader
      title={<Text t="pendingApprovalTransactions" />}
      showBreadCrumb
      showHelpButton
    >
      {notificationList && notificationList?.length > 0 ? (
        <>
          <ProcessType />
          {componentsToRender.map(({ key, component }) => (
            <Fragment key={key}>{component}</Fragment>
          ))}
          <CustomButton
            style={{
              color: '#162056',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              border: 'none',
              background: 'none',
            }}
            onClick={() => history.push('/')}
          >
            <CustomImage src={leftBack} />
            <Text t="returnToHomePage2" />
          </CustomButton>
        </>
      ) : (
        <></>
      )}
    </CustomPageHeader>
  );
};

export default PendingApproval;
